import { useAdContext } from '../contexts/ad';

interface AdActionsReturn {
  invalidateCache: () => void;
  invalidatePricesCache: () => void;
}

export function AdActions(): AdActionsReturn {
  const { dispatchForm } = useAdContext();

  function invalidateCache() {
    dispatchForm({
      type: 'INVALIDATE_CACHE'
    });
  }

  function invalidatePricesCache() {
    dispatchForm({
      type: 'INVALIDATE_PRICES_CACHE'
    });
  }

  return {
    invalidateCache,
    invalidatePricesCache
  };
}
